import CryptoJS from 'crypto-js';

const SECRET_KEY = 'mova-whitelabel';

const eventListeners = new Map();

let tokenUpdateCallback = null;

const emitEvent = (key, value) => {
  if (eventListeners.has(key)) {
    eventListeners.get(key).forEach(callback => {
      try {
        callback(value);
      } catch (error) {
        console.error('Erro ao executar callback do evento:', error);
      }
    });
  }
  
  if (key === 'idToken' && tokenUpdateCallback) {
    try {
      tokenUpdateCallback(value);
    } catch (error) {
      console.error('Erro ao executar callback global do token:', error);
    }
  }
};

/**
 * Criptografa uma string
 * @param {string} text - Texto a ser criptografado
 * @returns {string} - Texto criptografado
 */
export const encrypt = (text) => {
  if (!text) return '';
  
  try {
    const encodedText = encodeURIComponent(text);
    const encryptedText = window.btoa ? window.btoa(encodedText + SECRET_KEY) : encodedText;
    return encryptedText;
  } catch (error) {
    console.error('Erro ao criptografar:', error);
    return text; // Retorna o texto original em caso de erro
  }
};

/**
 * Descriptografa uma string
 * @param {string} encryptedText - Texto criptografado
 * @returns {string} - Texto descriptografado
 */
export const decrypt = (encryptedText) => {
  if (!encryptedText) return '';
  
  try {
    if (window.atob) {
      const decodedText = window.atob(encryptedText);
      const originalText = decodedText.replace(SECRET_KEY, '');
      return decodeURIComponent(originalText);
    }
    return encryptedText; // Retorna o texto original se atob não estiver disponível
  } catch (error) {
    console.error('Erro ao descriptografar:', error);
    return encryptedText; // Retorna o texto original em caso de erro
  }
};

/**
 * Verifica se o localStorage está disponível
 * @returns {boolean}
 */
const isLocalStorageAvailable = () => {
  try {
    const test = '__storage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Salva um valor criptografado no localStorage
 * @param {string} key - Chave do localStorage
 * @param {string} value - Valor a ser criptografado e salvo
 */
export const secureLocalStorage = {
  setItem: (key, value) => {
    if (!isLocalStorageAvailable()) {
      console.warn('localStorage não está disponível');
      return;
    }
    try {
      const encryptedValue = encrypt(value);
      localStorage.setItem(key, encryptedValue);
      if (key === 'idToken') {
        emitEvent(key, value);
      }
    } catch (error) {
      console.error('Erro ao salvar no localStorage:', error);
    }
  },
  
  getItem: (key) => {
    if (!isLocalStorageAvailable()) {
      console.warn('localStorage não está disponível');
      return null;
    }
    try {
      const encryptedValue = localStorage.getItem(key);
      if (!encryptedValue) return null;
      return decrypt(encryptedValue);
    } catch (error) {
      console.error('Erro ao ler do localStorage:', error);
      return null;
    }
  },
  
  removeItem: (key) => {
    if (!isLocalStorageAvailable()) {
      console.warn('localStorage não está disponível');
      return;
    }
    try {
      localStorage.removeItem(key);
      // Emitir evento para remoção do idToken
      if (key === 'idToken') {
        emitEvent(key, null);
      }
    } catch (error) {
      console.error('Erro ao remover do localStorage:', error);
    }
  },

  // Métodos para gerenciar listeners de eventos
  addEventListener: (key, callback) => {
    if (!eventListeners.has(key)) {
      eventListeners.set(key, new Set());
    }
    eventListeners.get(key).add(callback);
  },

  removeEventListener: (key, callback) => {
    if (eventListeners.has(key)) {
      eventListeners.get(key).delete(callback);
    }
  },

  setTokenUpdateCallback: (callback) => {
    tokenUpdateCallback = callback;
  },

  removeTokenUpdateCallback: () => {
    tokenUpdateCallback = null;
  }
};

export const hashData = (data) => {
  if (!data) return '';
  const cleanData = data.replace(/\D/g, '');
  return CryptoJS.SHA256(cleanData).toString();
}; 
